import { TFunction } from 'i18next';
import { TableColumn } from 'react-data-table-component';
import { NavigateFunction } from 'react-router-dom';
import { WaProduct } from 'src/api/wa/store/models/product/WaProduct';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';

export const productRelatedColumns = (
  t: TFunction,
  navigate: NavigateFunction,
  setSelectedProduct: (selectedProduct: WaProduct | null) => void,
  products: WaProduct[] | null
): TableColumn<WaProduct>[] => {
  return [
    {
      id: 'productNumber',
      name: t('wards.siteDetails.seNumber'),
      selector: (r) => String(r.productNumber ?? ''),
      cell: (r) => (
        <LinkButton
          title={`${r.productNumber ?? ''}`}
          onClick={() => {
            const productWithDisaster = products?.find((p) => p.productNumber === r.productNumber);
            if (productWithDisaster) {
              r = productWithDisaster; // Use the product with disaster info if available
            }

            setSelectedProduct(r);
            wardsNavigate(navigate, WaScreensMap[WA_Screen.ProductDetails].path);
          }}
          className="text-left"
        />
      ),
      sortable: true,
      grow: 1,
    },
    {
      id: 'machineUnit',
      name: t('wards.siteDetails.unit'),
      selector: (r) => String(r.unit ?? ''),
      sortable: true,
      grow: 1,
    },
    {
      id: 'contract',
      name: t('wards.siteDetails.contract'),
      selector: (r) => r.contractName ?? '',
      sortable: true,
      grow: 1,
    },
    {
      id: 'deviceModel',
      name: t('wards.siteDetails.deviceModel'),
      selector: (r) => r.model ?? '',
      sortable: true,
      grow: 1,
    },
  ];
};
